import {
    type OpenApiSchemaAggregatedProductCard,
    type OpenApiSchemaLightAggregatedProductCard,
    type OpenApiSchemaLightProductVariant,
    type OpenApiSchemaMediaItemV2,
    type OpenApiSchemaProductVariantListItem,
} from '#shared/api/schema';
import { type ProductCardForGallery } from '../CardsGalleryItem';

export function getProductVariantMediaItems(
    variant: OpenApiSchemaProductVariantListItem | OpenApiSchemaLightProductVariant | undefined
): OpenApiSchemaMediaItemV2[] {
    if (!variant) {
        return [];
    }

    if ('media_items' in variant) {
        return variant.media_items;
    }

    return variant.image
        ? [
              {
                  display_sequence: 1,
                  type: 'IMAGE',
                  payload: variant.image,
              },
          ]
        : [];
}

export function mapProductCardForGallery(
    card: OpenApiSchemaAggregatedProductCard | OpenApiSchemaLightAggregatedProductCard
): ProductCardForGallery {
    const {
        id,
        name,
        price_range: { min: priceFrom, max: priceTo },
        variants,
    } = card;

    const media = getProductVariantMediaItems(variants.at(0)).at(0);

    return { id, name, priceFrom, priceTo, media };
}
